import { MecProduct } from '@adapters/bigcommerce/types/product';
import ProductComparisonCheckbox from '../ProductComparisonCheckbox';
import SimpleLink from '_components/UI/SimpleLink';

import styles from './ProductBrandAndComparison.module.scss';

interface ProductBrandAndComparisonProps {
  product: MecProduct;
  productCode: string;
}

const ProductBrandAndComparison = ({
  product,
  productCode,
}: ProductBrandAndComparisonProps) => {
  const hasBrandLink =
    typeof product.brandURL === 'string' &&
    product.brandURL.trim().length > 0 &&
    !!product.brand?.name;

  return (
    <div className={styles.container}>
      {hasBrandLink && (
        <SimpleLink href={product.brandURL}>
          {product.brand?.name || ''}
        </SimpleLink>
      )}
      <ProductComparisonCheckbox product={{ ...product, code: productCode }} />
    </div>
  );
};

export default ProductBrandAndComparison;
